module.exports = __webpack_public_path__ + "static/media/RefugeeStories.54210a99.png";